import http from "../../../utils/services/http-client";

class NotificationService {
  getNotification(isSeen:boolean) {
    return http.get(`/UserNotifications`);
  }
  updateNotificationStatus(id:string) {
    return http.put(`/UserNotifications/` + id+'/Seen' );
  }


}

export default new NotificationService();
